import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Json from "../../../gatsby-config"

const Layout = props => {
  let imageclass = ""
  imageclass = props.imageclass
  const image = getImage(props.imagename)
  return (
    <>
      {props.imagename !== null && (
        <GatsbyImage image={image} alt={props.alt} className={imageclass} />
      )}

      {props.youtube !== null &&
        props.imagename === null &&
        props.vimeo === null && (
          <div className="ratio ratio-16x9">
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${props.youtube}?autoplay=1&version=3&rel=0&mute=1&controls=0&playlist=${props.youtube}&loop=1&origin=${Json.siteMetadata.siteUrl}`}

              allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; "
              title={`"${props.alt}"`}
              allowFullScreen="1"
            />
          </div>
        )}
      {props.vimeo !== null &&
        props.imagename === null &&
        props.youtube === null && (
          <div className="ratio ratio-16x9">
            <iframe
              src={`https://player.vimeo.com/video/${props.vimeo}?muted=1&autoplay=1&loop=1&autopause=0&title=0&byline=0&portrait=0`}
              title={props.alt}
              allow="autoplay; fullscreen"
              allowFullScreen
            ></iframe>
          </div>
        )}
    </>
  )
}
export default Layout
